export default __webpack_public_path__ + "static/media/Boots of the Chaos Agent.8f167f06.jpg";